import { DatePicker } from 'antd';
import type { DateTime } from 'luxon';
import luxonGenerateConfig from 'rc-picker/lib/generate/luxon';
import React from 'react';
import { calculateDisabledDate } from './calculateDisabledDate';
import { calculateDisabledTime } from './calculateDisabledTime';

const CustomDatePicker = DatePicker.generatePicker<DateTime>(luxonGenerateConfig);
type DatePickerProps = React.ComponentProps<typeof CustomDatePicker>;

type Props = DatePickerProps & {
  minDate?: DateTime;
};

const DatePickerComponent: React.FC<Props> = React.forwardRef(
  ({ minDate, maxDate, ...props }, ref) => {
    return (
      <CustomDatePicker
        {...props}
        disabledTime={(current) => calculateDisabledTime({ current, minDate, maxDate })}
        disabledDate={(current) => calculateDisabledDate({ current, minDate, maxDate })}
        ref={ref}
      />
    );
  },
);

export default DatePickerComponent;
